<template>
    <div>
        <p
            v-if="!calc.assumptions"
            class="text-body-large text--typography1 mt-0"
        >
            This calculation has no assumptions.
        </p>
        <ul v-else>
            <li
                v-for="(a, i) in calc.assumptions"
                :key="i"
                class="mt-2 mb-2 text-wrap"
                v-html="makeAssumption(a)"
            ></li>
        </ul>
    </div>
</template>

<script setup>
defineProps(['calc'])

function decodeHTMLEntities(str) {
    const doc = new DOMParser().parseFromString(str, 'text/html')
    return doc.documentElement.textContent
}

function insertWbrInTextNodes(text) {
    const container = document.createElement('div')
    container.textContent = text

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT)
    const textNodes = []
    let node
    while ((node = walker.nextNode())) textNodes.push(node)

    textNodes.forEach((textNode) => {
        const value = textNode.nodeValue
        if (!value || !value.includes('/')) return

        const parts = value.split('/')
        const frag = document.createDocumentFragment()

        parts.forEach((part, idx) => {
            if (idx > 0) {
                frag.appendChild(document.createElement('wbr'))
                frag.appendChild(document.createTextNode('/'))
            }
            if (part) frag.appendChild(document.createTextNode(part))
        })

        textNode.parentNode.replaceChild(frag, textNode)
    })

    return container.innerHTML
}

function makeAssumption(assumption) {
    const decoded = decodeHTMLEntities(assumption)
    return insertWbrInTextNodes(decoded)
}
</script>
